import React, { ReactElement, useEffect, useState } from "react";
import styles from "./ValidatorsPage.module.scss";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "../../models/enums";
import { IndexerService } from "../../services/indexer.service";
import { Validator, ValidatorsInfo } from "../../models/Validator";
import ValidatorsTable from "./ValidatorsTable";
import { NodesList, Node, RelatedNode } from "../../models/Node";
import { ValidatorsFilter } from "../../components/validatorsFilter/ValidatorsFilter";
import { Group } from "@mantine/core";
import { UNKNOWN_NAME } from "../../constants";
import { fivePercentOfGwei } from "../../utils/formatter";
import { useStore } from "@tanstack/react-store";
import { IStore, store } from "../../services/store.service";
declare const window: any;

export default function ValidatorsPage(): ReactElement | null {
  const timeZone = useStore<IStore, IStore["timeZone"]>(store, (state) => state.timeZone).selected;
  const [validators, setValidators] = useState<Validator[] | null>(null);
  const [filteredValidators, setFilteredValidators] = useState<
    Validator[] | null
  >(null);

  const { data: validatorsInfo } = useQuery({
    queryKey: [QueryKey.validatorList],
    queryFn: (): Promise<ValidatorsInfo> => IndexerService.getValidatorList(),
  });

  const { data: nodesList } = useQuery({
    queryKey: [QueryKey.nodes],
    queryFn: (): Promise<NodesList> => IndexerService.getNodes(),
  });

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_title: "Validators",
        page_location: window.location.href,
      });
    }
  }, []);

  function enrichValidatorsData(
    validators: Validator[],
    nodes: Node[],
    capLimitBase: number | null
  ): void {
    const enrichedValidators = validators.map((validator: Validator) => {
      const node = nodes.find((n: Node) => n.nodeId === validator.nodeID);

      let totalFtsoStake = validator.totalStake;
      if (!node) {
        validator.capLimit =
          capLimitBase === null ? undefined : capLimitBase - totalFtsoStake;
        validator.roi = null;
        validator.name = UNKNOWN_NAME;
        return validator;
      }

      node.relatedNodes.forEach((relatedNode: RelatedNode) => {
        const relatedValidator = validators.find(
          (val: Validator) => val.nodeID === relatedNode.nodeId
        );
        if (relatedValidator) {
          totalFtsoStake += relatedValidator.totalStake;
        }
      });

      validator.roi = node.roi ?? 0;
      validator.name = node.name ?? UNKNOWN_NAME;
      validator.ftsoAddress = node.ftsoAddress;
      validator.capLimit =
        capLimitBase === null ? undefined : capLimitBase - totalFtsoStake;

      return validator;
    });
    setValidators(enrichedValidators);
    setFilteredValidators(enrichedValidators);
  }

  useEffect(() => {
    if (validatorsInfo && nodesList) {
      enrichValidatorsData(
        validatorsInfo.validators,
        nodesList.nodes,
        fivePercentOfGwei(validatorsInfo.total)
      );
    }
  }, [validatorsInfo, nodesList]);

  return (
    <>
      <div className={styles.txContainer}>
        <Group justify={"center"} className={styles.filter}>
          <ValidatorsFilter
            validators={validators}
            setValidators={setFilteredValidators}
          />
        </Group>

        <div className={styles.tableWrapper}>
          <div className={styles.tableHolder}>
            <ValidatorsTable timeZone={timeZone} validators={filteredValidators} />
          </div>
        </div>
      </div>
    </>
  );
}
